export default __webpack_public_path__ + "static/media/GregoryPluijm.0637ca81.webp";